// test2874
(2874 && 0);
